'use client';

import { isBrowser } from '@/lib/utils';

export const isIos = () => {
  if (!isBrowser()) return false;
  const userAgent = window.navigator.userAgent.toLowerCase();
  return /iphone|ipad|ipod/.test(userAgent);
};

export const isInStandaloneMode = () => {
  if (!isBrowser()) return false;
  return 'standalone' in window.navigator && window.navigator.standalone;
};
